"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GumballTransformParameterApi_parameter;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGumballTransformParameterApi = exports.GumballTransformParameterApi = void 0;
const ParameterApi_1 = require("./ParameterApi");
class GumballTransformParameterApi extends ParameterApi_1.ParameterApi {
    constructor(parameter) {
        super(parameter);
        _GumballTransformParameterApi_parameter.set(this, void 0);
        __classPrivateFieldSet(this, _GumballTransformParameterApi_parameter, parameter, "f");
    }
    get interactionType() {
        return __classPrivateFieldGet(this, _GumballTransformParameterApi_parameter, "f").interactionType;
    }
    get settings() {
        return __classPrivateFieldGet(this, _GumballTransformParameterApi_parameter, "f").settings;
    }
}
exports.GumballTransformParameterApi = GumballTransformParameterApi;
_GumballTransformParameterApi_parameter = new WeakMap();
const isGumballTransformParameterApi = (obj) => obj instanceof GumballTransformParameterApi;
exports.isGumballTransformParameterApi = isGumballTransformParameterApi;
//# sourceMappingURL=GumballTransformParameterApi.js.map